export default __webpack_public_path__ + "images/0xf26b3fd147619df61d4c1d0a9f7200b31a73fafa.png";